// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"421443d5","244":"a9f0c377","271":"e53ee175","331":"1939c342","543":"ada3f034","570":"62f5a7ba","747":"49dee9d6","783":"46fa486f","803":"013ce309","950":"3a85c226"}[chunkId] + ".chunk.js";
};